<template>
  <div>
    <div class="dashboard-info-widgets d-flex justify-content-around flex-column flex-md-row">

      <!-- Days with Screenings -->
      <va-card class="info-widget brand-info">
        <div class="info-widget-inner">
          <div class="stats">
            <div class="stats-number">
              <i class="fa fa-calendar stats-icon icon-wide"></i>
              <count v-if="daysWithScreenings >= 0" :to="daysWithScreenings"></count>
              <span v-else v-text="daysWithScreenings"></span>
            </div>
            <div class="stats-title"> {{ $t('statistics.csm.days_with_screenings') }}
            </div>
          </div>
        </div>
      </va-card>

      <!-- Number Users -->
      <va-card class="info-widget brand-info">
        <div class="info-widget-inner">
          <div class="stats">
            <div class="stats-number">
              <i class="fa fa-user stats-icon icon-wide"></i>
              <count v-if="users >= 0" :to="users"></count>
              <span v-else v-text="users"></span>
            </div>
            <div class="stats-title">{{ $t('statistics.csm.users') }}
            </div>
          </div>
        </div>
      </va-card>

      <!-- Number appointments -->
      <va-card class="info-widget brand-info">
        <div class="info-widget-inner">
          <div class="stats">
            <div class="stats-number">
              <i class="fa fa-list-ul stats-icon icon-wide"></i>
              <count v-if="appointments >= 0" :to="appointments"></count>
              <span v-else v-text="appointments"></span>
            </div>
            <div class="stats-title">{{ $t('statistics.csm.appointments') }}
            </div>
          </div>
        </div>
      </va-card>

      <!-- Number records made -->
      <va-card class="info-widget brand-info">
        <div class="info-widget-inner">
          <div class="stats">
            <div class="stats-number">
              <!--<i class="fa fa-trash stats-icon icon-wide"></i>-->
              <i class="va-icon fa fa-calendar-check-o mr-1" style="font-size: 1.7rem;"></i>
              <count v-if="totalRecordsMade >= 0" :to="totalRecordsMade"></count>
              <span v-else v-text="totalRecordsMade"></span>
            </div>
            <div class="stats-title">
              {{$t('statistics.csm.total_registrations_performed')}}
            </div>
          </div>
        </div>
      </va-card>
    </div>
    <div class="dashboard-info-widgets d-flex justify-content-around flex-column flex-md-row">
      <!-- Number submitted -->
      <va-card class="info-widget brand-info">
        <div class="info-widget-inner">
          <div class="stats">
            <div class="stats-number">
              <i class="fa fa-bullseye stats-icon icon-wide"></i>
              <count v-if="submitted >= 0" :to="submitted"></count>
              <span v-else v-text="submitted"></span>
            </div>
            <div class="stats-title"> {{ $t('statistics.csm.submitted') }}
            </div>
          </div>
        </div>
      </va-card>

      <!-- Number LQ -->
      <va-card class="info-widget brand-info">
        <div class="info-widget-inner">
          <div class="stats">
            <div class="stats-number">
              <i class="fa fa-deaf stats-icon icon-wide"></i>
              <count v-if="lq >= 0" :to="lq"></count>
              <span v-else v-text="lq"></span>
            </div>
            <div class="stats-title"> {{$t('statistics.csm.lq')}}
            </div>
          </div>
        </div>
      </va-card>

      <!-- LQ per Day -->
      <va-card class="info-widget brand-info">
        <div class="info-widget-inner">
          <div class="stats">
            <div class="stats-number">
              <i class="fa fa-pie-chart stats-icon icon-wide"></i>
              <count v-if="avgLqDay >= 0" :to="avgLqDay"></count>
              <span v-else v-text="avgLqDay"></span>
            </div>
            <div class="stats-title">{{ $t('statistics.csm.avg_lq_day') }}
            </div>
          </div>
        </div>
      </va-card>

      <!-- LQ per Entity -->
      <va-card class="info-widget brand-info">
        <div class="info-widget-inner">
          <div class="stats">
            <div class="stats-number">
              <i class="fa fa-check stats-icon icon-wide"></i>
              <count v-if="avgLqEntity >= 0" :to="avgLqEntity"></count>
              <span v-else v-text="avgLqEntity"></span>
            </div>
            <div class="stats-title"> {{$t('statistics.csm.avg_lq_entity')}}
            </div>
          </div>
        </div>
      </va-card>
    </div>
  </div>
</template>

<script>
import Count from '@/components/common/Count'
import IsFromEvollu from '@/mixins/IsFromEvolluMixin'
export default {
  name: 'dashboard-info-widgets',
  components: {
    Count
  },
  mixins: [IsFromEvollu],
  props: {
    daysWithScreenings: {
      type: Number,
      required: true
    },
    users: {
      type: Number,
      required: true
    },
    appointments: {
      type: Number,
      required: true
    },
    totalRecordsMade: {
      type: Number,
      required: true
    },
    submitted: {
      type: Number,
      required: true
    },
    lq: {
      type: Number,
      required: true,
      default: 0
    },
    avgLqDay: {
      type: Number,
      required: true,
      default: 0
    },
    avgLqEntity: {
      type: Number,
      required: true,
      default: 0
    }
  }
}
</script>

<style lang="scss">
.widget.brand-info {
  box-shadow: 0px 0px 0px #29c4a9;
}

</style>
<style lang="scss" scoped>

.info-widget{
  flex-basis: 20%;
}

.stats-number, .stats-title {
  line-height: 1;
}

.info-widget-inner {
  display: flex;
  flex-direction: row;
  align-items: center;
  justify-content: center;
  position: relative;
  width: 100%;

  &.has-chart {
    justify-content: space-between;
  }

  .stats {
    display: flex;
    flex-direction: column;
    justify-content: center;
    align-items: center;
    height: 100%;
  }
}

.stats-number {
  position: relative;
  display: flex;
  flex-direction: row;
  align-items: center;
  justify-content: center;
  font-size: 2.625rem;
  margin-bottom: 0.5rem;

  .stats-icon {
    font-size: 1.5625rem;
    position: absolute;
    top: 0.625rem;
    left: -1.25rem;

    &.icon-wide {
      left: -1.875rem;
    }
  }
}
</style>
